import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import { message } from 'antd'
import ChangePwd from './changepwd'

export default function Main() {
    const navigate = useNavigate()
    const [isChangePwdVisible, setIsChangePwdVisible] = useState(false)

    const handleLogout = () => {
        localStorage.removeItem('token')
        localStorage.removeItem('merchant_oid')
        navigate('/login')
        message.success('退出登录成功')
    }

    const handleChangePwd = () => {
        setIsChangePwdVisible(true)
    }

    return (
        <div className="main-page">
            <div className="main-header">
                <div className="main-left">
                    <img src="/images/logo.png" alt="" />
                    <span>兰州职业技术学院就业系统管理后台</span>
                </div>
                <div className="main-right">
                    <div className="main-right-item" onClick={handleChangePwd}>修改密码</div>
                    <div className="main-right-item" onClick={handleLogout}>退出登陆</div>
                </div>
            </div>

            <div className="main-outlet">
                <Outlet />
            </div>

            {isChangePwdVisible && <ChangePwd
                isOpen={isChangePwdVisible}
                isCancel={() => { setIsChangePwdVisible(false) }}
            />}
        </div>
    )
}
